import axios from "axios"
import { createModel } from "xstate/lib/model"

export const authModel = createModel(
    // Initial context
    {
        username: undefined as string | undefined,
        password: undefined as string | undefined,
        resetPasswordConfirmationCode: undefined as string | undefined,
        emailConfirmationCode: undefined as string | undefined,
        isActive: false,
        isQuestionary: false,
        debug: false,
    },
    {
        events: {
            LOG_IN: () => ({}),
            SET_USERNAME: (username: string) => ({ username }),
            SET_PASSWORD: (password: string) => ({ password }),
            SWITCH_AUTH: () => ({}),
            SIGN_UP: () => ({}),
            TO_EMAIL_CONFIRMATION: () => ({}),
            RESEND_EMAIL: () => ({}),
            SET_VERIFICATION_CODE: (emailConfirmationCode: string) => ({ emailConfirmationCode }),
            SET_RESET_CODE: (resetPasswordConfirmationCode: string) => ({ resetPasswordConfirmationCode }),
            VERIFY_EMAIL: () => ({}),
            TO_RESET_PASSWORD: () => ({}),
            REQUEST_RESET_PASSWORD: () => ({}),
            TO_CONFIRM_RESET_PASSWORD: () => ({}),
            CONFIRM_RESET_PASSWORD: () => ({}),
            LOG_OUT: () => ({}),
            CHECK_TO_PASS_THROUGH_TO_APP: () => ({}),
            PASS_THROUGH_TO_APP: () => ({}),
            TO_AUTH_PAGE: () => ({}),
            SET_ACTIVATION_STATUS: (isActive: boolean) => ({ isActive }),
            SET_QUESTIONARY_STATUS: (isQuestionary: boolean) => ({ isQuestionary }),
        },
    }
)

export const authMachine = authModel.createMachine(
    {
        /** @xstate-layout N4IgpgJg5mDOIC5QEMCuAXAFgOgMabFwGsBBDTAYgAUSBlWgfQBUAJAJQHkBVAcReY4MSVKgG0ADAF1EoAA4B7WAEt0S+QDsZIAB6IALAGYAHNnFnxAVj0AmIwDYjZu3YA0IAJ6IAnHewWjBgYAjNYG-sEA7HpBAL4xbmhYeATEZFgUTIIkXKwMNDwAohLSSCAKyqoaWroIFtZungh2IdgBBnriRkHiXuJ6cQnk2ImYVMgw2AA28lAAkuoAYvIATgC2FAAyHDwMswByxVrlKmqapTUOJkEWdtZeel3i1nr3DYhB10F+AQ9BwcFWOwDEAjYbkMYTaZzRYrda0ADqsyYAGF+NlWIdSsdKmdQBcjFcbndfk8Xno3ggQnVvu1nAYvAZrBYDMDQSMIWApjN5ks1hRaAUmAwuAK2HsSABZIpSI6KE5Vc6ICziL7MrwhFW3ewGCndZXYOwGPo9CJBHzOfrxEFDdnjTlQnmwjKCNgFAVCmj0eEcNgAEUxcjlOOqiEu2Gut3uj2erw83isrUCegiFgZfysLKtbPBdq5UCgSnU0OodEYrE4vH4mSEIgDZSDpxDlM1pn+jL+KYMES8uvEKZpyes1hVXa8rJtOchMwLRfmzqEOX4+WlJUDFUbioQETsET8wTuNzsdSPrjjlO6X06YReKt6zKBWYnWA52GUUHUXFkvLhsx4e2FYgyliDYKniiBGMO2AREY6phBEfbBMmuphAYA4WEEyaBOhFjjkktoTG+H5fk6CJIqiC4YkBa7yriOiIBEESocyfwXsqXhRPUZ4atYpgBMyHReOqdS4Tg+GcoRn7fvygrCqK4pSnW2IbmBzbXKYFrqvYN4RJxjQhHovjWH8PxRtERg4Y+eGTuJSjvpJTrVq67p5KW3p+opIG0TUfyGgaRgpr0yYWNhyHJuGzhdM0OleEYNgiWCz65oRhZQJ+84FBKJCzBsDDIhwewLLMbCZUwsz5R566gXRTQEuGRJRt0MbklxarYOxKp6Km9wGIaFmDFZiUEbZ6gpWl1bokuJCFBVNFNmGEbEtGZLIeIqFXvS9j+de8ViXgGgAGZKGsBSrMgSiTFJzkAGoFGwsyFciJClfluUcL6K6ypVXnvKSrSxYYEEEgDOotV2BrOIJ9I3DY-g7dZe3qIdx2nedUlOQUey+gwGVZRsM3BpuPmoQ4AV9CmIVcXYBlQat-ixUE-n+BEcODZyuAHUdqwnWdF1Ojdd0LAAmtjmXZfjynVQxJjWIxyY+H0wV3LqqbiNgya3v5jg9bElmifDyxwGA6gQCl3PnSW9DMOw3B8AINaAau9ZfU2QTbr46pPPBgRPH0yvNNgw49T49zYduLOjLmBuwEbJtFmbkzpaLOV5QVRUlWVBxUU7s2E9EqswX2ISmn25PKz4Ae02Ehoy3YnThy+ABuYDLEo+3uKbKMJ56ZbW5WdvCA7n05ypKEGnonU3Nu48hCDenMqhBLwaajFMpP9e5k3Ldtx3POJ7jr2p8VT0Z+LVX4oSkYkk1upU6r7VMhGvVjrrCURxMUdgOgYywLAADuKwQEujJEUt15IfWAs7Qm8EvgMSiDcWK9JtyhS+IaJ4O5VoQ3sOvd+hsv7IB-v-ZYgCnSugAIpcDdEKdGHpXI+n9FnJSZ93j0i+BBPoRpugGU6Mhdi4MHCdFNEaQImZ+p61ZtgA2ABHVAcBVBFjYLg7+f8AHzhToVYqDBqEuS9HQ0+31KQ9WJozQK5NrjKyeBXLsVMjx6jsM-URr8XxSJkbAORUAFHRzwQQlRjk3QyW7m5ehjtGH6KJn5UmQUKZ6XHlcCKzQXi9CNEYbBbMOZrA8Z-KSai06aL8TQnR7kGGeSbMOewashxmACNuPoQRlbdADv5cQzhmiOF6PY60A036pMRpzFKGSvHKKIRbHuFZbbjVrEUyBKlnh2LHgZAkoQEK6hsHoKC9gGTRFrnY1MKSEZI1WH0xR+DBkQFUfldREpcnOQCboyZw9qqlN8DYYcV5qnRGWamNZUQvAWG7D4LW4cjaqFwMgdAkBNjbAYNwJgeiSlDhpkae4QlnDdiMBSF4PF1pdFNLXaIoR4pQhnFADgGB5wTRctNO5BMVK3F1NcVCXZ2gdB+HLS0Vp1DyAgHALQIwh7UuqgAWlPI0IV8V8CEFIOQPlEsag2ApF0Pw5hrgYOCDuZmL8xLSqYQgIcXg6q3HgtY555l5U7mwMIrhMFlRdktA43aDoYRrC1fo48Y9Yr2BTEOWwwr3jXExXxaIwUPYy12YSlK8xnVNkEjxKKMsMI6X8M0OlwReK0mTNEGwARdkSWIk6iB9zvKrR4himWPQYbrNCruZpvQjzRBrequ18NkpFk-JGzcgRdxmGgr8swVh7gRGQkaAcZNoI2J1o28R7MenIx5t+NtKk9SrK6BmplDIeo33pOGYcMzbAMR2Rq-WhtjY73OvO6qQQ7GqxsGaWKRkhwYQsDfC9CLvmMQ+MFXZm9W7tzjp3M9NQZa7gWoagyxrH0tRgua-y+l0LmSsNYXZH8BmEOIXm6i-LvKXvKTe6997OrLMMKm9CDJ+GIUQ2AaRsjDmeKUSh-93hbjhMPMEC9QNll-HCjuLoEFtztAQweydaTVj9LnfmjD7wIIWANOha4vQApeGsD6ykyoeJewJOhGwPyeq7Knfs6jn9aMAPozq+kqEIwdCMkXDoSmMKOAaXY9ZBk7HGEBeoYFoLIDGZ3OihTNJjCuwvTU-FL8w1FhJegYzYQpMWj7MyMwHwjTNUaAZPV60bHjwBHEOIQA */
        id: "auth",
        context: authModel.initialContext,
        initial: "checkAuth",
        on: {
            SET_ACTIVATION_STATUS: {
                actions: authModel.assign({ isActive: (_, e) => e.isActive }),
            },
            SET_QUESTIONARY_STATUS: {
                actions: authModel.assign({ isQuestionary: (_, e) => e.isQuestionary }),
            },
        },
        states: {
            checkAuth: {
                initial: "default",
                invoke: {
                    id: "authMachine-checkSession",
                    src: "checkSession",
                },
                on: {
                    PASS_THROUGH_TO_APP: {
                        target: ".authenticated",
                    },
                    TO_AUTH_PAGE: {
                        target: "authPage",
                    },
                    LOG_OUT: {
                        target: "loggingOut",
                        // actions: ["trackAction"],
                    },
                },
                states: {
                    default: {},
                    authenticated: {},
                },
            },
            authPage: {
                initial: "logInForm",
                on: {
                    CHECK_TO_PASS_THROUGH_TO_APP: {
                        target: "checkAuth",
                        actions: authModel.assign({ username: undefined, password: undefined }),
                    },
                },
                states: {
                    logInForm: {
                        on: {
                            LOG_IN: {
                                target: "loggingIn",
                            },
                            SWITCH_AUTH: {
                                target: "signUpForm",
                            },
                            SET_USERNAME: {
                                actions: authModel.assign({ username: (_, ev) => ev.username.toLowerCase() }),
                            },
                            SET_PASSWORD: {
                                actions: authModel.assign({ password: (_, ev) => ev.password }),
                            },
                            TO_RESET_PASSWORD: {
                                target: "resetPasswordForm",
                            },
                        },
                    },
                    loggingIn: {
                        invoke: {
                            id: "authMachine-logIn",
                            src: "logIn",
                        },
                        on: {
                            TO_AUTH_PAGE: {
                                target: "logInForm",
                            },
                        },
                    },
                    signUpForm: {
                        on: {
                            SIGN_UP: {
                                target: "signingUp",
                            },
                            SWITCH_AUTH: {
                                target: "logInForm",
                            },
                            SET_USERNAME: {
                                actions: authModel.assign({ username: (_, ev) => ev.username.toLowerCase() }),
                            },
                            SET_PASSWORD: {
                                actions: authModel.assign({ password: (_, ev) => ev.password }),
                            },
                            TO_RESET_PASSWORD: {
                                target: "resetPasswordForm",
                            },
                        },
                    },
                    signingUp: {
                        invoke: {
                            id: "authMachine-signUp",
                            src: "signUp",
                        },
                        on: {
                            TO_EMAIL_CONFIRMATION: {
                                target: "confirmEmailForm",
                            },
                            TO_AUTH_PAGE: {
                                target: "signUpForm",
                            },
                        },
                    },
                    confirmEmailForm: {
                        on: {
                            SET_VERIFICATION_CODE: {
                                actions: authModel.assign({ emailConfirmationCode: (_, ev) => ev.emailConfirmationCode }),
                            },
                            RESEND_EMAIL: {
                                target: "resendingEmail",
                            },
                            VERIFY_EMAIL: {
                                target: "verifyingEmail",
                            },
                        },
                    },
                    resendingEmail: {
                        invoke: {
                            id: "authMachine-resendEmail",
                            src: "resendEmailApiCall",
                        },
                        on: {
                            TO_EMAIL_CONFIRMATION: {
                                target: "confirmEmailForm",
                            },
                        },
                    },
                    verifyingEmail: {
                        invoke: {
                            id: "authMachine-verifyEmail",
                            src: "verifyEmailApiCall",
                        },
                        on: {
                            TO_EMAIL_CONFIRMATION: {
                                target: "confirmEmailForm",
                            },
                            TO_AUTH_PAGE: {
                                target: "signUpForm",
                            },
                        },
                    },
                    resetPasswordForm: {
                        on: {
                            SET_USERNAME: {
                                actions: authModel.assign({ username: (_, ev) => ev.username.toLowerCase() }),
                            },
                            REQUEST_RESET_PASSWORD: {
                                target: "requestingResetPassword",
                            },
                        },
                    },
                    requestingResetPassword: {
                        invoke: {
                            id: "authMachine-requestResetPassword",
                            src: "requestResetPasswordApiCall",
                        },
                        on: {
                            TO_CONFIRM_RESET_PASSWORD: {
                                target: "confirmResetForm",
                                actions: authModel.assign({ password: undefined }),
                            },
                            TO_RESET_PASSWORD: {
                                target: "resetPasswordForm",
                            },
                        },
                    },
                    confirmResetForm: {
                        on: {
                            CONFIRM_RESET_PASSWORD: {
                                target: "confirmingResetPassword",
                            },
                            SET_PASSWORD: {
                                actions: authModel.assign({ password: (_, ev) => ev.password }),
                            },
                            SET_RESET_CODE: {
                                actions: authModel.assign({ resetPasswordConfirmationCode: (_, ev) => ev.resetPasswordConfirmationCode }),
                            },
                        },
                    },
                    confirmingResetPassword: {
                        invoke: {
                            id: "authMachine-confirmResetPassword",
                            src: "confirmResetPasswordApiCall",
                        },
                        on: {
                            TO_CONFIRM_RESET_PASSWORD: {
                                target: "confirmResetForm",
                            },
                        },
                    },
                },
            },
            loggingOut: {
                invoke: {
                    id: "authMachine-logOut",
                    src: "logOut",
                },
                on: {
                    TO_AUTH_PAGE: {
                        target: "authPage",
                    },
                },
            },
        },
    },
    {
        services: {
            checkSession: () => async (send) => {
                const session = localStorage.getItem("session")
                if (!session) send("TO_AUTH_PAGE")
                const sessionObj = session && JSON.parse(session)
                if (!sessionObj?.accessToken) {
                    localStorage.removeItem("session")
                    send("TO_AUTH_PAGE")
                }

                refreshToken(sessionObj)
                const intervalID = setInterval(() => refreshToken(sessionObj), sessionObj.expiresIn * 1000 - 10000)

                function refreshToken(sessionObj: any) {
                    if (!sessionObj?.refreshToken) {
                        clearInterval(intervalID)
                        return
                    }
                    axios
                        .post(`${process.env.REACT_APP_QUORINI_AUTH_API}/refresh-token`, {
                            authOption: { refreshToken: sessionObj.refreshToken, username: sessionObj.username },
                        })
                        .then((response) => {
                            if (response.status === 200 && response.data.accessToken) {
                                localStorage.setItem("session", JSON.stringify({ ...response.data, username: sessionObj.username.toLowerCase() }))
                                send({ type: "SET_ACTIVATION_STATUS", isActive: response.data.isActive })
                                send({ type: "SET_QUESTIONARY_STATUS", isQuestionary: response.data.isQuestionary })
                                send("PASS_THROUGH_TO_APP")
                            } else {
                                localStorage.removeItem("session")
                                send("TO_AUTH_PAGE")
                            }
                        })
                        .catch((e) => {
                            console.error(e)
                            localStorage.removeItem("session")
                            send("TO_AUTH_PAGE")
                            clearInterval(intervalID)
                        })
                }

                return () => clearInterval(intervalID)
            },
            logIn: (ctx) => (send) => {
                axios
                    .post(`${process.env.REACT_APP_QUORINI_AUTH_API}/log-in`, {
                        authOption: { username: ctx.username, password: ctx.password },
                    })
                    .then((response) => {
                        // console.log(response)
                        if (response.status === 200 && response.data.accessToken) {
                            localStorage.setItem("session", JSON.stringify({ ...response.data, username: ctx.username }))
                            send({ type: "SET_ACTIVATION_STATUS", isActive: response.data.isActive })
                            send({ type: "SET_QUESTIONARY_STATUS", isQuestionary: response.data.isQuestionary })
                            send("CHECK_TO_PASS_THROUGH_TO_APP")
                        } else {
                            send("TO_AUTH_PAGE")
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        send("TO_AUTH_PAGE")
                    })
            },
            signUp: (ctx) => (send) => {
                axios
                    .post(`${process.env.REACT_APP_QUORINI_AUTH_API}/sign-up`, {
                        authOption: { username: ctx.username, password: ctx.password },
                    })
                    .then(() => {
                        send("TO_EMAIL_CONFIRMATION")
                    })
                    .catch((e) => {
                        console.error(e)
                        send("TO_AUTH_PAGE")
                    })
            },
            resendEmailApiCall: (ctx) => async (send) => {
                await axios.get(`${process.env.REACT_APP_QUORINI_AUTH_API}/resend-verification-email/?username=${ctx.username}`).catch((e) => {
                    console.error(e)
                })
                send("TO_EMAIL_CONFIRMATION")
            },
            verifyEmailApiCall: (ctx) => (send) => {
                axios
                    .get(
                        `${process.env.REACT_APP_QUORINI_AUTH_API}/verify-email/?code=${ctx.emailConfirmationCode}&username=${ctx.username?.replace("+", "%2B")}`
                    )
                    .then(() => {
                        axios
                            .post(`${process.env.REACT_APP_QUORINI_AUTH_API}/log-in`, {
                                authOption: { username: ctx.username, password: ctx.password },
                            })
                            .then((response) => {
                                // console.log(response)
                                if (response.status === 200 && response.data.accessToken) {
                                    localStorage.setItem("session", JSON.stringify({ ...response.data, username: ctx.username }))
                                    send({ type: "SET_ACTIVATION_STATUS", isActive: response.data.isActive })
                                    send({ type: "SET_QUESTIONARY_STATUS", isQuestionary: response.data.isQuestionary })
                                    send("CHECK_TO_PASS_THROUGH_TO_APP")
                                } else {
                                    send("TO_AUTH_PAGE")
                                }
                            })
                            .catch((e) => {
                                console.error(e)
                                send("TO_AUTH_PAGE")
                            })
                    })
                    .catch((e) => {
                        console.error(e)
                        send("TO_EMAIL_CONFIRMATION")
                    })
            },
            requestResetPasswordApiCall: (ctx) => (send) => {
                axios
                    .get(`${process.env.REACT_APP_QUORINI_AUTH_API}/request-reset-password/?username=${ctx.username}`)
                    .then((res) => {
                        send("TO_CONFIRM_RESET_PASSWORD")
                    })
                    .catch((e) => {
                        console.error(e)
                        send("TO_RESET_PASSWORD")
                    })
            },
            confirmResetPasswordApiCall: (ctx) => (send) => {
                axios
                    .post(`${process.env.REACT_APP_QUORINI_AUTH_API}/confirm-reset-password/?code=${ctx.resetPasswordConfirmationCode}`, {
                        authOption: { username: ctx.username, password: ctx.password },
                    })
                    .then(() => {
                        send("CHECK_TO_PASS_THROUGH_TO_APP")
                    })
                    .catch((e) => {
                        console.error(e)
                        send("TO_CONFIRM_RESET_PASSWORD")
                    })
            },
            logOut: () => (send) => {
                console.log("logOut func")
                localStorage.removeItem("session")
                send("TO_AUTH_PAGE")
            },
        },
        actions: {
            // trackAction: (context, event) => {
            //     console.log("ACTION_EVENT", event.type)
            // },
        },
    }
)
